// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__JvC98","label":"Section_label__3wqYq","contentWrap":"Section_contentWrap__1k6WI","footer":"Section_footer__1eVt_","footerInner":"Section_footerInner__3Q59h"};